import {
    Button,
    Box,
    Typography,
    useTheme,
    useMediaQuery,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Fab
} from "@mui/material";
import "../styles/bidding-card.scss";
import CloseIcon from '@mui/icons-material/Close';
import CarCard from "./CarCard";
import React from "react";
import { CountdownTimer } from "./CountdownTimer";
import { useEffect, useState } from "react";
import { betBidding, tryBet, getBiddingById } from "./api";
import ImageWithDefault from "./ImageWithDefault";
import { setNotificationMessage, setShowNotification } from "../store";
import * as signalR from '@microsoft/signalr';

const userBetEmodji = ["🥇", "🥈", "🥉"];
const webSocketUrl = process.env.REACT_APP_SOCKET_URL;

export const BiddingCard = (props) => {
    const [connection, setConnection] = useState(null);
    const { biddingId, onClose } = props;

    const [openDialog, setOpenDialog] = useState(false);
    const [bidding, setBidding] = useState({
        id: 0,
        cars: [],
        city: {
            id: 0,
            name: ""
        },
        duration: 0,
        startPrice: 0,
        dateEndBidding: null,
        currentPrice: 0,
        betStep: 0,
        userBets: []
    });
    const [biddingChanged, setBiddingChanged] = useState(false);
    const [betPrice, setBetPrice] = useState(0);

    useEffect(() => {
        if (!connection) {
            const newConnection = new signalR.HubConnectionBuilder()
                .withUrl(`${webSocketUrl}/sockets/biddings`, {
                    skipNegotiation: true,
                    transport: signalR.HttpTransportType.WebSockets
                })
                .build();

            setConnection(newConnection);
        }
    }, []);

    useEffect(() => {
        if (connection && biddingId) {
            connection.start().then(() => {
                connection.invoke("SendBidding", biddingId);
                connection.on("BiddingUpdate", (data) => {
                    setBidding(JSON.parse(data));
                });
            }).catch((exception) => console.log(exception));
        }
    }, [connection, biddingId]);

    useEffect(() => {
        const originalStyle = window.getComputedStyle(document.body).overflow;

        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = originalStyle;
        };
    }, []);

    const handleClickOpen = () => {
        const currentBetPrice = bidding.currentPrice + bidding.betStep;
        setBetPrice(currentBetPrice);
        tryBet({ biddingId: bidding.id, betPrice: currentBetPrice })
            .then(data => {
                setBiddingChanged(false);
                if (data?.hasActiveSubscription && data?.currentUserNotHasTopBet) {
                    if (data?.currentBetIsMax) {
                        setOpenDialog(true);
                    }
                    else {
                        getBiddingById(bidding.id)
                            .then(data => {
                                setBidding(data);
                                setBetPrice(data.currentPrice + data.betStep);
                                setBiddingChanged(true);
                                setOpenDialog(true);
                            })
                            .catch(error => {
                                setNotificationMessage("Произошла непредвиденная ошибка");
                                setShowNotification(true);
                            })
                    }
                }
                else if (!data?.hasActiveSubscription) {
                    setNotificationMessage("У вас нет активной подписки");
                    setShowNotification(true);
                }
                else if (!data?.currentUserNotHasTopBet) {
                    setNotificationMessage("Ваша ставка уже лидирует");
                    setShowNotification(true);
                }
                else {
                    setNotificationMessage("Произошла непредвиденная ошибка");
                    setShowNotification(true);
                }
            })
            .catch(error => {
                const errorMessageData = error?.response?.data?.errors;
                setNotificationMessage(errorMessageData
                    ? Array.from(errorMessageData).join(", ")
                    : "Произошла непредвиденная ошибка");
                setShowNotification(true);
            });
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const betBiddingClick = () => {
        console.log(betPrice);
        betBidding({
            biddingId: biddingId,
            betPrice: betPrice
        })
            .then(data => {
                setBidding(data);
                setBiddingChanged(false);
                setOpenDialog(false);
            })
            .catch(error => {
                const errorMessageData = error?.response?.data?.errors;
                setNotificationMessage(errorMessageData
                    ? Array.from(errorMessageData).join(", ")
                    : "Произошла непредвиденная ошибка");
                setShowNotification(true);
                setOpenDialog(false);
                getBiddingById(bidding.id)
                    .then(data => {
                        setBidding(data);
                        setBiddingChanged(false);
                    })
            });

    };

    const timeUp = (dateEnd) => {
        const now = new Date();
        const end = new Date(dateEnd);

        return now > end;
    }

    const getHidenNameAndPrice = (name, price) => {
        return `${name.slice(0, 2)}*** - ${price.toLocaleString()} ₽`
    }

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <div className="bidding-card__layout" style={isMobile ? { height: "calc(100vh - 120px)", position: "fixed" } : {}}>
            <div className="bidding-card" style={isMobile ? { maxHeight: "calc(100vh - 140px)", height: "100%", width: "100%" } : {}}>
                {bidding.id !== 0 &&
                    <React.Fragment>
                        <h3 className="bidding-card__title">
                            {`Лот № ${bidding.id} `}
                            {bidding.cars.length > 1 && (`Автомобильное комбо! ${bidding.cars.length} АВТО ПО ЦЕНЕ 1`)}
                        </h3>

                        <div className="bidding-card__main-information">

                            <ImageWithDefault src={bidding?.fileName} className="bidding-card__main-image" />
                            <h4>🌍 {bidding.city?.name}</h4>
                            {bidding.cars.map(item =>
                                <CarCard car={item} key={item.id} />
                            )}
                        </div>

                        <div className="bidding-card__functional_info">
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", width: "100%", textAlign: "center" }}>
                                <div>
                                    <Box>
                                        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                            Длительность:
                                        </Typography>
                                        <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                            {bidding.duration}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                            Начальная цена:
                                        </Typography>
                                        <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                            {bidding.startPrice.toLocaleString()} ₽
                                        </Typography>
                                    </Box>
                                </div>
                                <div>
                                    <Box>
                                        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                            Оставшееся время:
                                        </Typography>
                                        <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                            {bidding?.dateEndBidding ? <CountdownTimer endTime={bidding.dateEndBidding} /> : "Время вышло!"}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                            Текущая цена:
                                        </Typography>
                                        <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                            {bidding.currentPrice.toLocaleString()} ₽
                                        </Typography>
                                    </Box>
                                </div>

                            </div>
                            <div className="bidding-card__user-bets">
                                {bidding.userBets.map((userBet, index) => (
                                    <p key={index}>{index < 3 && `${userBetEmodji[index]} `}{getHidenNameAndPrice(userBet.user.fullName, userBet.betPrice.toLocaleString())}</p>
                                ))}
                                {!timeUp(bidding.dateEndBidding) && <Button
                                    variant="contained"
                                    color="primary"
                                    className="bidding-card__bet-button"
                                    onClick={() => handleClickOpen()}
                                >
                                    {(bidding.currentPrice + bidding.betStep).toLocaleString()} ₽
                                </Button>}
                            </div>

                        </div>
                    </React.Fragment>
                }


                <CloseIcon className='bidding-card__close-button' onClick={onClose} />
            </div>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Подтвердите ставку"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {biddingChanged && (`Стоимость торга увлечилась, текущая стоимость: ${bidding.currentPrice}. `)}
                        Вы подтверждаете ставку {(bidding.currentPrice + bidding.betStep).toLocaleString()}&nbsp;₽?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => betBiddingClick()} autoFocus>
                        Да
                    </Button>
                    <Button onClick={handleClose}>Нет</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}